import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'

import { useAppDepsContext } from '~/core/hooks/useAppDepsContext'
import PATHS from '~/router/paths'

interface LocationState {
  from: {
    pathname: string
    search: string
  }
}

export default function useLogin() {
  const { authService } = useAppDepsContext()
  const location = useLocation<LocationState>()
  const pathName = location.state
    ? `${location.state.from.pathname}${location.state.from.search}`
    : ''
  const state = pathName.includes('login') ? PATHS.SALES_START : pathName
  const [shouldReload, setShouldReload] = useState(false)

  useEffect(() => {
    const reloadSubs = authService.reloadSubs().subscribe(setShouldReload)
    return () => {
      reloadSubs.unsubscribe()
    }
  })

  useEffect(() => {
    authService.authenticate({ state })
  }, [])

  useEffect(() => {
    if (shouldReload) {
      window.location.reload()
    }
  }, [shouldReload])

  async function authenticate() {
    authService.authenticate({ state })
  }

  return { authenticate }
}
